<template>
  <iframe
    class="rounded"
    width="100%"
    style="aspect-ratio: 16 / 9"
    allowfullscreen
    :src="block.value"
  ></iframe>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';
defineProps<{block: SphereBlock<'embed_block'>}>();
</script>
